<template>

    <div>

        <informacion-general-modal
            :data="data"
            :id="id"
            :dataVer="dataVer"
            :load="loading"
        />
    
    </div>
  </template>
  
  <script>
    
    import { mapActions } from 'vuex';

    import InformacionGeneralModal from "../../../../../components/modals/lineas/booking/bookings_confirmados/InformacionGeneralModal.vue";
    import { verBookingItineraries } from "../../../../../constants/lineas";
    
    export default {

        props : ["id", "booking_itinerary_id", "data"],
        data() {
            return {
                loading : false,
                dataVer : []
            };
        },

        components: {
            InformacionGeneralModal
        },

        methods: {

            ...mapActions(["ActionSetZindexTablaModal"]),
            ...mapActions("serviciosLogisticos",["actionSetAbrirVerDetalleModal"]),
            ...mapActions("lineas",["actionSetVisibleModalInformacionGeneral"]),

            async cargarDetalleBooking(){

                this.loading = true;
                this.$vToastify.loader("Cargando información de Booking");

                this.dataVer = await verBookingItineraries({
                    id_booking: this.id,
                    booking_itinerary_id:  this.booking_itinerary_id
                });

                this.$vToastify.stopLoader();
                this.actionSetVisibleModalInformacionGeneral(true);
                this.loading = false;

            }


        },

        watch : {

            id : function(){
                this.cargarDetalleBooking();
            }

        }

    };

  </script>
  
  <style>
    #verBookingModal .ui-modal--size-normal > .ui-modal__wrapper > .ui-modal__container {
        width: 75% !important;
    }
  </style>
  